import React, { useEffect } from "react"
import PropTypes from "prop-types"
import ResourceSelector from "./ResourceSelector";

import API from "../../../Common/API";

const UserSelector = (props) => {

    const getQueryParams = () => {
        let queryParams = {};

        if (props.belongsToUnits.length) {
            queryParams['belongsToUnits'] = props.belongsToUnits
        }

        return queryParams;
    }

    return (
        <ResourceSelector
            {...props}
            type={'users'}
            noOptionsMessage={() => "Type to select from users"}
            queryParams={getQueryParams()}
        />
    )
}

UserSelector.propTypes = {
    name: PropTypes.string,
    multi: PropTypes.bool,
    belongsToUnits: PropTypes.array,
    value: PropTypes.any,
    placeholder: PropTypes.string,
    isClearable: PropTypes.bool
}

UserSelector.defaultProps = {
    name: 'users',
    multi: false,
    value: null,
    belongsToUnits: [],
    isClearable: false,
}

export default UserSelector;
